import React, { useState, useEffect, useCallback } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Customize_Css/Pagination.css';
import '../Customize_Css/ViewCategoryImage.css';
import { Dropdown, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaTrashAlt, FaFileExport, FaEdit } from 'react-icons/fa';
import Sidebar from '../Components/Siderbar';
import Footer from '../Components/Footer';
import { toast } from 'react-toastify';
import axios from 'axios';
import * as XLSX from 'xlsx';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Switch,
  FormControlLabel,
  Box,
  Typography,
} from '@mui/material';

const ViewCategoryImage = () => {
  const navigate = useNavigate();
  const epicxTenantId = localStorage.getItem('epicxTenantId');
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const AuthorizationToken = localStorage.getItem('token');
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [selectedItems, setSelectedItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editCategory, setEditCategory] = useState({
    _id: '',
    categoryName: '',
    categoryType: '',
    vegOrNonVeg: '',
    categoryImage: '',
    selectedColor: { name: '', code: '' },
  });
  const [useFileUpload, setUseFileUpload] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [errors, setErrors] = useState({});
  const [validFields, setValidFields] = useState({});

  const colors = [
    { name: 'Mint Green', code: '#E9FFF1' },
    { name: 'Peach Orange', code: '#FEF6ED' },
    { name: 'Light Salmon', code: '#FDE8E4' },
    { name: 'Lavender', code: '#F4EBF7' },
    { name: 'Pale Yellow', code: '#FEF8E5' },
    { name: 'Light Sky Blue', code: '#EDF7FC' },
  ];

  // Validation logic for individual fields
  const validateField = (id, value) => {
    const isEmpty = (val) => !val || val.toString().trim() === '';
    const validationRules = {
      categoryName: {
        message: 'Category Name is required',
        validator: (val) => !isEmpty(val),
      },
      categoryType: {
        message: 'Category Type is required',
        validator: (val) => !isEmpty(val),
      },
      vegOrNonVeg: {
        message: 'Veg/Non-Veg selection is required',
        validator: (val) => !isEmpty(val),
      },
      categoryImage: {
        message: 'Category Image is required',
        validator: (val) => (useFileUpload ? !!imageFile : !isEmpty(val)),
      },
    };

    const rule = validationRules[id];
    if (!rule) return true;

    const isValid = rule.validator(value);
    setErrors((prev) => ({
      ...prev,
      [id]: isValid ? '' : rule.message,
    }));
    setValidFields((prev) => ({
      ...prev,
      [id]: isValid,
    }));
    return isValid;
  };

  // Validate all fields
  const validateForm = () => {
    const fieldsToValidate = ['categoryName', 'categoryType', 'vegOrNonVeg', 'categoryImage'];
    let isValid = true;

    fieldsToValidate.forEach((id) => {
      const value = id === 'categoryImage' ? (useFileUpload ? imageFile : editCategory.categoryImage) : editCategory[id];
      if (!validateField(id, value)) {
        isValid = false;
      }
    });

    return isValid;
  };

  // Fetch Categories
const fetchCategories = useCallback(async () => {
  setIsLoading(true);
  try {
    const response = await axios.get(`${BASE_URL}/products/api/category/${epicxTenantId}`, {
      headers: {
        Authorization: `Bearer ${AuthorizationToken}`,
      },
    });

    console.log('Raw API response.data:', response.data);
    const categories = Array.isArray(response.data)
      ? response.data
      : Array.isArray(response.data?.categories)
        ? response.data.categories
        : Array.isArray(response.data?.data)
          ? response.data.data
          : [];

    setData(categories);
    setOriginalData(categories);
  } catch (error) {
    console.error('Error fetching categories:', error);
    toast.error(`Error fetching categories: ${error.message}`);
    setData([]);
    setOriginalData([]);
  } finally {
    setIsLoading(false);
  }
}, [BASE_URL, AuthorizationToken, epicxTenantId]);
  useEffect(() => {
    fetchCategories();
  }, [fetchCategories,epicxTenantId]);

  // Clean up object URL for image preview
  useEffect(() => {
    return () => {
      if (imageFile) {
        URL.revokeObjectURL(URL.createObjectURL(imageFile));
      }
    };
  }, [imageFile]);

  // Sorting
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
    const sortedData = [...data].sort((a, b) => {
      let aValue = a[key];
      let bValue = b[key];
      aValue = aValue ? aValue.toString().toLowerCase() : '';
      bValue = bValue ? bValue.toString().toLowerCase() : '';
      if (aValue < bValue) {
        return direction === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
    setData(sortedData);
  };

  // Search
  const handleSearch = (value) => {
    const lowercasedValue = value.toLowerCase();
    setSearchTerm(lowercasedValue);

    if (lowercasedValue === '') {
      setData(originalData);
    } else {
      const filteredData = originalData.filter((item) =>
        Object.keys(item).some((key) =>
          item[key]?.toString().toLowerCase().includes(lowercasedValue)
        )
      );
      setData(filteredData);
    }

    setCurrentPage(1);
  };

  // Select/Deselect all items
  const handleSelectAll = () => {
    if (selectedItems.length === data.length) {
      setSelectedItems([]);
    } else {
      setSelectedItems(data.map((item) => item._id));
    }
  };

  // Select individual item
  const handleSelectItem = (_id) => {
    if (selectedItems.includes(_id)) {
      setSelectedItems(selectedItems.filter((item) => item !== _id));
    } else {
      setSelectedItems([...selectedItems, _id]);
    }
  };

  // Delete selected items
  const handleDelete = async () => {
    if (selectedItems.length === 0) {
      toast.warn('No items selected to delete');
      return;
    }
    const confirmed = window.confirm('Are you sure you want to delete the selected categories?');
    if (!confirmed) return;

    setIsLoading(true);
    try {
      const deletePromises = selectedItems.map((itemId) =>
        axios.put(
          `${BASE_URL}/products/api/category/delete/${epicxTenantId}/${itemId}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${AuthorizationToken}`,
            },
          }
        )
      );
      await Promise.all(deletePromises);
      const updatedData = data.filter((item) => !selectedItems.includes(item._id));
      setData(updatedData);
      setOriginalData(originalData.filter((item) => !selectedItems.includes(item._id)));
      setSelectedItems([]);
      toast.success('Selected categories deleted successfully!');
    } catch (error) {
      console.error('Error deleting categories:', error);
      toast.error('Error deleting categories. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  // Open edit modal
  const handleEdit = async () => {
    if (selectedItems.length === 1) {
      const selectedId = selectedItems[0];
      try {
        const response = await axios.get(`${BASE_URL}/products/api/category/${epicxTenantId}/${selectedId}`, {
          headers: {
            Authorization: `Bearer ${AuthorizationToken}`,
          },
        });
        const categoryData = response.data;
        const backgroundColor = categoryData.backgroundColor
          ? categoryData.backgroundColor.split(',')
          : ['', ''];
        setEditCategory({
          _id: categoryData._id,
          categoryName: categoryData.categoryName || '',
          categoryType: categoryData.categoryType || '',
          vegOrNonVeg: categoryData.vegOrNonVeg || '',
          categoryImage: categoryData.categoryImage || '',
          selectedColor: {
            name: backgroundColor[0] || '',
            code: backgroundColor[1] || '',
          },
        });
        setShowEditModal(true);
        setErrors({});
        setValidFields({});
        setImageFile(null);
        setUseFileUpload(false);
      } catch (error) {
        console.error('Error fetching category data:', error);
        toast.error('Error fetching category data.');
      }
    } else {
      toast.error('Please select exactly one category to edit.');
    }
  };

  // Export data
  const handleExport = () => {
    const dataToExport =
      selectedItems.length > 0
        ? data.filter((item) => selectedItems.includes(item._id))
        : data;
    const exportData = dataToExport.map((item) => ({
      categoryName: item.categoryName,
      categoryType: item.categoryType,
      vegOrNonVeg: item.vegOrNonVeg,
      createdAt: item.createdAt,
    }));
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Category');
    XLSX.writeFile(wb, 'CategoryImages_data.xlsx');
  };

  // Handle input changes
  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditCategory((prev) => ({ ...prev, [name]: value }));
    validateField(name, value);
  };

  // Handle file change
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (imageFile) {
      URL.revokeObjectURL(URL.createObjectURL(imageFile));
    }
    setImageFile(file);
    validateField('categoryImage', file);
  };

  // Toggle image upload
  const handleImageToggle = () => {
    setUseFileUpload((prev) => !prev);
    setImageFile(null);
    validateField('categoryImage', null);
  };

  // Handle color selection
  const handleColorSelectSubCategories = (color) => {
    setEditCategory((prev) => ({
      ...prev,
      selectedColor: color,
    }));
  };

  // Save edited category
  const handleSaveEdit = async () => {
    if (!validateForm()) {
      toast.error('Please fix the errors before saving.');
      return;
    }

    try {
      const formData = new FormData();
      formData.append('categoryName', editCategory.categoryName);
      formData.append('categoryType', editCategory.categoryType);
      formData.append('vegOrNonVeg', editCategory.vegOrNonVeg);

      if (editCategory.selectedColor && editCategory.selectedColor.name && editCategory.selectedColor.code) {
        formData.append('backgroundColor', `${editCategory.selectedColor.name},${editCategory.selectedColor.code}`);
      } else {
        formData.append('backgroundColor', '');
      }

      if (useFileUpload && imageFile) {
        formData.append('categoryImage', imageFile);
      } else {
        formData.append('categoryImage', editCategory.categoryImage);
      }

      await axios.put(`${BASE_URL}/products/api/category/${epicxTenantId}/${editCategory._id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${AuthorizationToken}`,
        },
      });

      await fetchCategories();
      toast.success('Category updated successfully!');
      setShowEditModal(false);
    } catch (error) {
      console.error('Error updating category:', error);
      toast.error('Error updating category.');
    }
  };

  // Format date
  const formatDate = (dateString) => {
    const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-GB', options);
  };

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = data.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(data.length / itemsPerPage);

  // Define column widths for perfect alignment
  const columnWidths = {
    checkbox: '50px',
    categoryName: '150px',
    categoryType: '120px',
    vegOrNonVeg: '100px',
    categoryImage: '100px',
    backgroundColor: '190px',
    createdAt: '100px',
  };

  const editFieldSx = {
    '& .MuiOutlinedInput-root': {
      borderRadius: '12px',
      '&.Mui-focused fieldset': { borderColor: '#12956a' },
    },
    '& .MuiInputLabel-root.Mui-focused': { color: '#12956a' },
  };

  const editSelectSx = {
    borderRadius: '12px',
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#12956a' },
  };

  return (
    <>
      <Sidebar />
      <div className="category-list-page">
        <div className="category-list-top">
          <div>
            <button
              type="button"
              className="category-back"
              onClick={() => navigate('/Add-product-image')}
            >
              ← Back
            </button>
            <h1>Category List</h1>
            <p className="category-lead">Saved category images. Search, sort, or use Action to edit, delete, or export.</p>
          </div>
          <div className="category-list-tools">
            <input
              type="text"
              className="form-control category-search"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => handleSearch(e.target.value)}
            />
            <Dropdown>
              <Dropdown.Toggle className="category-action">
                Action
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={handleDelete}>
                  <FaTrashAlt className="me-2" /> Delete
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={handleEdit}
                  disabled={selectedItems.length !== 1}
                >
                  <FaEdit className="me-2" /> Edit
                </Dropdown.Item>
                <Dropdown.Item onClick={handleExport}>
                  <FaFileExport className="me-2" /> Export
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        <div className="category-list-card">
          <div className="category-list-scroll">
            {isLoading ? (
              <div className="category-loading">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <Table hover responsive className="category-table" style={{ tableLayout: 'fixed' }}>
                <thead>
                  <tr>
                    <th style={{ width: columnWidths.checkbox }}>
                      <input
                        type="checkbox"
                        checked={selectedItems.length === data.length && data.length > 0}
                        onChange={handleSelectAll}
                      />
                    </th>
                    {[
                      'categoryName',
                      'categoryType',
                      'vegOrNonVeg',
                      'categoryImage',
                      'backgroundColor',
                      'createdAt',
                    ].map((key) => (
                      <th
                        key={key}
                        onClick={() => handleSort(key)}
                        style={{
                          width: columnWidths[key],
                          cursor: 'pointer',
                        }}
                      >
                        {key === 'vegOrNonVeg'
                          ? 'Veg/Non-Veg'
                          : key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1')}
                        {sortConfig.key === key ? (sortConfig.direction === 'asc' ? ' ▲' : ' ▼') : ''}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {currentData.map((item) => {
                    const colorParts = String(item.backgroundColor || '').split(',');
                    const colorName = colorParts[0]?.trim();
                    const colorCode = colorParts[1]?.trim();
                    return (
                      <tr
                        key={item._id}
                        className={selectedItems.includes(item._id) ? 'selected-row' : ''}
                      >
                        <td style={{ width: columnWidths.checkbox }}>
                          <input
                            type="checkbox"
                            checked={selectedItems.includes(item._id)}
                            onChange={() => handleSelectItem(item._id)}
                          />
                        </td>
                        <td style={{ width: columnWidths.categoryName }}>
                          {item.categoryName || 'N/A'}
                        </td>
                        <td style={{ width: columnWidths.categoryType }}>
                          {item.categoryType || 'N/A'}
                        </td>
                        <td style={{ width: columnWidths.vegOrNonVeg }}>
                          {item.vegOrNonVeg || 'N/A'}
                        </td>
                        <td style={{ width: columnWidths.categoryImage }}>
                          {item.categoryImage ? (
                            <img
                              src={item.categoryImage}
                              alt={item.categoryName}
                              className="category-thumb"
                            />
                          ) : (
                            'No Image'
                          )}
                        </td>
                        <td style={{ width: columnWidths.backgroundColor }}>
                          {colorName ? (
                            <span className="category-color">
                              <span
                                className="category-color-dot"
                                style={{ backgroundColor: colorCode || '#fff' }}
                              />
                              {colorName}
                            </span>
                          ) : (
                            'N/A'
                          )}
                        </td>
                        <td style={{ width: columnWidths.createdAt }}>
                          {formatDate(item.createdAt)}
                        </td>
                      </tr>
                    );
                  })}
                  {currentData.length === 0 && (
                    <tr>
                      <td colSpan="7" className="category-empty">
                        No categories found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            )}
          </div>
          <div className="category-list-footer">
            <span className="category-total">
              {`Total Categories: ${data.length}`}
            </span>
            <ul className="category-pager">
              <li>
                <button type="button" onClick={() => setCurrentPage(1)} disabled={currentPage === 1}>
                  «
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                  disabled={currentPage === 1}
                >
                  ‹
                </button>
              </li>
              <li>
                <button type="button" className="is-active">
                  {currentPage}
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages || 1))}
                  disabled={currentPage === totalPages || totalPages === 0}
                >
                  ›
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => setCurrentPage(totalPages || 1)}
                  disabled={currentPage === totalPages || totalPages === 0}
                >
                  »
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Edit Modal */}
        <Dialog
          open={showEditModal}
          onClose={() => setShowEditModal(false)}
          maxWidth="sm"
          fullWidth
          PaperProps={{ className: 'category-edit-paper' }}
        >
          <DialogTitle sx={{ px: 3, pt: 2.5, pb: 1 }}>
            <div className="category-edit-head">
              <div>
                <button
                  type="button"
                  className="category-back edit-back"
                  onClick={() => setShowEditModal(false)}
                >
                  ← Back
                </button>
                <h2>Edit Category</h2>
                <p>Update the details, then save. Back returns to the list without saving.</p>
              </div>
              <button
                type="button"
                className="category-edit-close"
                onClick={() => setShowEditModal(false)}
                aria-label="Close"
              >
                ×
              </button>
            </div>
          </DialogTitle>
          <DialogContent sx={{ px: 3, pt: '12px !important' }}>
            <Box display="flex" flexDirection="column" gap={2.5}>
              <TextField
                label="Category Name"
                name="categoryName"
                value={editCategory.categoryName}
                onChange={handleEditChange}
                fullWidth
                required
                variant="outlined"
                error={!!errors.categoryName}
                helperText={errors.categoryName}
                InputLabelProps={{ shrink: true }}
                sx={editFieldSx}
              />

              <FormControl fullWidth required error={!!errors.categoryType}>
                <InputLabel>Category Type</InputLabel>
                <Select
                  name="categoryType"
                  value={editCategory.categoryType}
                  onChange={handleEditChange}
                  label="Category Type"
                  sx={editSelectSx}
                >
                  <MenuItem value="">Select Category Type</MenuItem>
                  <MenuItem value="Perishable">Perishable</MenuItem>
                  <MenuItem value="Non-Perishable">Non-Perishable</MenuItem>
                </Select>
                {!!errors.categoryType && (
                  <Typography color="error" variant="caption">
                    {errors.categoryType}
                  </Typography>
                )}
              </FormControl>

              <FormControl fullWidth required error={!!errors.vegOrNonVeg}>
                <InputLabel>Veg/Non-Veg</InputLabel>
                <Select
                  name="vegOrNonVeg"
                  value={editCategory.vegOrNonVeg}
                  onChange={handleEditChange}
                  label="Veg/Non-Veg"
                  sx={editSelectSx}
                >
                  <MenuItem value="">Select Veg/Non-Veg</MenuItem>
                  <MenuItem value="Veg">Veg</MenuItem>
                  <MenuItem value="Non-Veg">Non-Veg</MenuItem>
                </Select>
                {!!errors.vegOrNonVeg && (
                  <Typography color="error" variant="caption">
                    {errors.vegOrNonVeg}
                  </Typography>
                )}
              </FormControl>

              <FormControlLabel
                control={
                  <Switch
                    checked={useFileUpload}
                    onChange={handleImageToggle}
                    sx={{
                      '& .MuiSwitch-switchBase.Mui-checked': {
                        color: '#12956a',
                      },
                      '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                        backgroundColor: '#12956a',
                      },
                    }}
                  />
                }
                label={useFileUpload ? 'Use File Upload' : 'Use Existing Image'}
              />

              <Box>
                <Typography variant="body2" gutterBottom sx={{ fontWeight: 700, color: '#1d3d34' }}>
                  Category Image *
                </Typography>
                <div className="category-edit-image">
                  {useFileUpload ? (
                    <Box>
                      <input
                        accept="image/*"
                        style={{ display: 'none' }}
                        id="category-image-upload"
                        type="file"
                        onChange={handleFileChange}
                      />
                      <label htmlFor="category-image-upload">
                        <Button
                          variant="contained"
                          component="span"
                          sx={{
                            backgroundColor: '#12956a',
                            borderRadius: '10px',
                            textTransform: 'none',
                            fontWeight: 700,
                            boxShadow: 'none',
                            '&:hover': { backgroundColor: '#0f8a62', boxShadow: 'none' },
                          }}
                        >
                          {imageFile ? 'Change Image' : 'Upload Image'}
                        </Button>
                      </label>
                      {imageFile && (
                        <Typography variant="caption" display="block" sx={{ mt: 1 }}>
                          {imageFile.name}
                        </Typography>
                      )}
                    </Box>
                  ) : null}
                  {(useFileUpload ? imageFile : editCategory.categoryImage) ? (
                    <img
                      src={useFileUpload ? URL.createObjectURL(imageFile) : editCategory.categoryImage}
                      alt="Category"
                    />
                  ) : (
                    <Typography variant="caption" color="text.secondary">
                      No image selected
                    </Typography>
                  )}
                </div>
                {!!errors.categoryImage && (
                  <Typography color="error" variant="caption">
                    {errors.categoryImage}
                  </Typography>
                )}
              </Box>

              <Box>
                <Typography variant="body2" gutterBottom sx={{ fontWeight: 700, color: '#1d3d34' }}>
                  Background Color
                </Typography>
                <div className="category-edit-swatches">
                  {colors.map((color) => (
                    <button
                      type="button"
                      key={color.code}
                      className={`category-edit-swatch ${editCategory.selectedColor?.name === color.name ? 'is-selected' : ''}`}
                      style={{ backgroundColor: color.code }}
                      title={color.name}
                      aria-label={color.name}
                      onClick={() => handleColorSelectSubCategories(color)}
                    />
                  ))}
                  <span className="category-edit-color-name">
                    {editCategory.selectedColor?.name || 'Select a color'}
                  </span>
                </div>
              </Box>
            </Box>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2.5, pt: 1 }}>
            <Button
              onClick={() => setShowEditModal(false)}
              variant="outlined"
              sx={{
                color: '#0f8a62',
                borderColor: '#1bbf86',
                borderRadius: '10px',
                textTransform: 'none',
                fontWeight: 700,
                '&:hover': { borderColor: '#0f8a62', backgroundColor: '#f3fbf8' },
              }}
            >
              Back
            </Button>
            <Button
              onClick={handleSaveEdit}
              variant="contained"
              sx={{
                backgroundColor: '#12956a',
                borderRadius: '10px',
                textTransform: 'none',
                fontWeight: 700,
                boxShadow: 'none',
                '&:hover': { backgroundColor: '#0f8a62', boxShadow: 'none' },
              }}
            >
              Update Category
            </Button>
          </DialogActions>
        </Dialog>

        <Footer />
      </div>
    </>
  );
};

export default ViewCategoryImage;